export default __webpack_public_path__ + "static/media/wokwok.ff0a783f.jpeg";